import { render, staticRenderFns } from "./AppointmentCoordinationWrapper.vue?vue&type=template&id=6a7437da"
import script from "./AppointmentCoordinationWrapper.vue?vue&type=script&lang=js"
export * from "./AppointmentCoordinationWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a7437da')) {
      api.createRecord('6a7437da', component.options)
    } else {
      api.reload('6a7437da', component.options)
    }
    module.hot.accept("./AppointmentCoordinationWrapper.vue?vue&type=template&id=6a7437da", function () {
      api.rerender('6a7437da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/appointmentManagement/AppointmentCoordinationWrapper.vue"
export default component.exports